<template>
    <div class="d-inline-flex align-center">
        <v-btn
            v-if="hasRejections"
            small
            rounded
            outlined
            color="error"
            @click="dialog = true"
        >
            <v-icon left small>mdi-format-list-bulleted</v-icon>
            Ver rejeições
        </v-btn>

        <v-dialog v-model="dialog" width="70%">
            <v-card>
                <v-card-title class="error white--text d-flex align-center">
                    <v-icon color="white" class="mr-2">mdi-alert-circle-outline</v-icon>
                    Histórico de rejeições
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-data-table
                        v-if="hasRejections"
                        :headers="headers"
                        :items="sortedRejections"
                        :items-per-page="5"
                        class="elevation-0"
                        no-data-text="Sem rejeições registadas"
                    >
                        <template v-slot:item.created_at="{ item }">
                            {{ formatDate(item.created_at) }}
                        </template>

                        <template v-slot:item.user="{ item }">
                            {{ getUserName(item) }}
                        </template>

                        <template v-slot:item.comment="{ item }">
                            <div class="py-2 rejection-comment">
                                {{ item.comment || '-' }}
                            </div>
                        </template>
                    </v-data-table>

                    <v-alert
                        v-else
                        outlined
                        type="info"
                        class="mb-0"
                    >
                        Sem rejeições registadas.
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        color="error"
                        @click="dialog = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'RejectionsHistory',

    props: {
        rejections: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            dialog: false,
            headers: [
                {
                    text: 'Data',
                    value: 'created_at',
                    sortable: false,
                    width: '180px',
                },
                {
                    text: 'Utilizador',
                    value: 'user',
                    sortable: false,
                    width: '220px',
                },
                {
                    text: 'Comentário',
                    value: 'comment',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        hasRejections() {
            return Array.isArray(this.rejections) && this.rejections.length > 0
        },

        sortedRejections() {
            if (!this.hasRejections) {
                return []
            }

            return [...this.rejections].sort((a, b) => {
                const dateA = new Date(a.created_at || 0).getTime()
                const dateB = new Date(b.created_at || 0).getTime()

                return dateB - dateA
            })
        },
    },

    methods: {
        getUserName(item) {
            if (!item) {
                return '-'
            }

            if (item.user && item.user.name) {
                return item.user.name
            }

            if (item.user && item.user.email) {
                return item.user.email
            }

            if (item.user_name) {
                return item.user_name
            }

            if (item.created_by) {
                return item.created_by
            }

            return '-'
        },

        formatDate(value) {
            if (!value) {
                return '-'
            }

            return value
        },
    },
}
</script>

<style scoped>
.rejection-comment {
    white-space: pre-wrap;
    line-height: 1.45;
}
</style>
